export default __webpack_public_path__ + "static/media/i-dropdown-arrow.1363e9a0.svg";